import { render, staticRenderFns } from "./CalendarProject.vue?vue&type=template&id=70315af8"
import script from "./CalendarProject.vue?vue&type=script&lang=js"
export * from "./CalendarProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports